import { createGenericDispatcher } from '../../action/action-dispatcher-factory';
import { addNotificationAction } from '../../action/notifications/notifications';

import * as Api from '../../api/api';

export const bulkRetryMessage = (messageIds: Array<number>) =>
  createGenericDispatcher({
    name: 'BULK_RETRY_MESSAGE',
    loadFunction: () =>
      Api.post('/message/bulk-retry', {
        body: JSON.stringify({ messageIds }),
      }),
    args: { messageIds },
    onSuccess: (dispatch: Function, _getState: Function, numResent: number) => {
      dispatch(
        addNotificationAction({
          key: 'bulk-retry-message-notification',
          message: `${numResent} message${numResent === 1 ? ' was' : 's were'} sent successfully`,
        }),
      );
    },
  });
